import React from 'react'
import { Layout, Space, Typography } from 'antd'
import { Link } from 'react-router-dom'
import { LegalMenu } from './LegalMenu'

const { Footer } = Layout
const { Text } = Typography

export const LayoutFooter: React.FC = () => {
  const year = new Date().getFullYear()

  return (
    <Footer style={{ padding: 15 }}>
      <LegalMenu />
    </Footer>
  )
}
